export default "__VITE_ASSET__ea2d937c__"